export function MenuItemDirective() {
  return {
    scope: {
      ngHref: '@',
      disabled: '<',
    },
    transclude: true,
    template: `<a class="button-link" ng-href="{{ngHref}}" ng-class="{ disabled: disabled }" ng-transclude></a>`,

    link: function ($scope, $elem, attrs, ctrl) {},
  };
}

export function MenuClipboardLinkDirective() {
  return {
    scope: {
      link: '<',
      disabled: '<',
      clipboardEnabled: '=',
      clipboardSuccess: '&',
    },
    transclude: true,
    template: `<a class="button-link" copy-to-clipboard clipboard-text="link" clipboard-enabled="clipboardEnabled" clipboard-success="clipboardSuccess()" ng-href ng-class="{ disabled: disabled }" ng-transclude></a>`,

    link: function ($scope, $elem, attrs, ctrl) {},
  };
}
